import { combineReducers } from 'redux';

import testHistoryReducer from './ducks/test-history';
import testHistoryViewsReducer from './ducks/test-history-view';
import testOverviewReducer from './ducks/test-overview';
import filtersReducer from './ducks/filters';
import general from './ducks/general';
import testSummaryReducer from './ducks/test-summary';
import testListReducer from './ducks/test-list';
import testErrorReducer from './ducks/test-error';
import failureAnalysisReducer from './ducks/failure-analysis';

const reducers = {
  testHistory: testHistoryReducer,
  testHistoryViews: testHistoryViewsReducer,
  testOverview: testOverviewReducer,
  filters: filtersReducer,
  generalReducer: general,
  testSummary: testSummaryReducer,
  testList: testListReducer,
  testError: testErrorReducer,
  failureAnalysis: failureAnalysisReducer,
};

export default combineReducers(reducers);
